<template>
  <div class="header" :class="{[`bg-${type}`]: type}" :style="bgImage">
    <div class="container-fluid">
      <div class="header-body">
        <slot></slot>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    name: 'base-header',
    props: {
      type: {
        type: String,
        default: 'primary',
        description: 'Header background type'
      }
    },
    computed:{
      bgImage(){
         if(this.type == 'pattern'){
          return `background-image: url(${require('../assets/background/'+ this.businessTypeCode +'/pattern.png')})`;
        }else if(this.type == 'instore'){
          return `background-image: url(${require('../assets/background/'+ this.businessTypeCode +'/instore.png')})`;
        }
      }
    },
    data(){
      return{
        businessTypeCode: JSON.parse(localStorage.getItem("businessTypeCode")),
      }
    }
  }
</script>
<style scoped>
.bg-pattern, .bg-instore{
  background-size: cover;
  background-position: center;
}
</style>
